import { gql } from '@apollo/client'

export const SAVE_TARGET_TEMPLATE = gql`
  mutation saveTargetTemplate($companyId: HashedId!, $country: Country!, $objective: ObjectiveTemplateInput!) {
    saveTargetTemplate(companyId: $companyId, country: $country, objective: $objective)
  }
`

export const DELETE_TARGET_TEMPLATE = gql`
  mutation deleteTargetTemplate($objectiveId: HashedId!, $companyId: HashedId!, $country: Country!) {
    deleteTargetTemplate(objectiveId: $objectiveId, companyId: $companyId, country: $country)
  }
`

export const DUPLICATE_TARGET_TEMPLATE = gql`
  mutation duplicateTargetTemplate($objectiveId: HashedId!, $companyId: HashedId!, $country: Country!) {
    duplicateTargetTemplate(objectiveId: $objectiveId, companyId: $companyId, country: $country)
  }
`
